function useApiFunction() {
  async function fetchApi(url, body, method) {
    let response = await fetch(
      `${process.env.REACT_APP_API_HOST_TESTING}${url}`,
      {
        method: `${method}`,
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      }
    );
    response = await response.json();
    return response;
  }
  async function fetchDataApi(url, body, method, token) {
    let response = await fetch(
      `${process.env.REACT_APP_API_HOST_TESTING}${url}`,
      {
        method: method,
        headers: {
          Authorization: `ok ${token}`,
          "Content-Type": "application/json",
        },

        body: body,
      }
    );
    response = await response.json();
    return response;
  }
  async function fetchFormDataApi(url, body, method, token) {
    let response = await fetch(
      `${process.env.REACT_APP_API_HOST_TESTING}${url}`,
      {
        method: method,
        headers: {
          Authorization: `ok ${token}`,
          // "Content-Type": `multipart/form-data; boundary=${body._boundary}`,

          Accept: "multipart/form-data",
        },

        body: body,
      }
    );
    response = await response.json();
    return response;
  }

  return {
    authFunc: fetchApi,
    formDataFunc: fetchDataApi,
    imageFunc: fetchFormDataApi,
  };
}

export default useApiFunction;
